import * as React from 'react';
import { useLocation } from 'react-router';

import { getRcVersionKeys, IRCVersionKeys } from './getRcVersionKeys';
import { useGetProductView } from './hooks/useGetProductView';
import { ProductDetail } from './ProductDetail';
import { ProductStateHandler } from './ProductStateHandler';

export interface ProductQueryParams {
  catalogId: number;
  productId: number;
  ssrEnabled: boolean;
}

const ProductDetailContainer: React.FC<ProductQueryParams> = ({
  catalogId,
  productId,
  ssrEnabled,
}) => {
  const location = useLocation();
  const { data, error, loading } = useGetProductView({
    catalogId,
    productId,
    ssrEnabled,
  });

  const keys: IRCVersionKeys = getRcVersionKeys(location);
  return (
    <ProductStateHandler
      data={data}
      error={error}
      loading={loading}
      productId={productId}
    >
      <ProductDetail
        PDView={data!} // the nullish scenario is handled in ProductStateHandler
        // because of SPA redirect for closing modals
        key={data?.productDetailByCatalogMasterId?.catalogMasterId}
        rcKey={keys.rcKey}
        customRcKey={keys.customRcKey}
        customVersionKey={keys.customVersionKey}
      />
    </ProductStateHandler>
  );
};

export default ProductDetailContainer;
